export default (function (arr) { return arr.slice(0, -1); });



//////////////////
// WEBPACK FOOTER
// ./~/@reecelucas/react-use-hotkeys/esm/helpers/takeUntilLast.js
// module id = 667
// module chunks = 0